
// 统一的matrix计算函数
function calculateMatrixValues() {
  let matrix_one, matrix_three, matrix_six;
  
  // 基础scale计算
  matrix_one = window.innerWidth / 918;
  matrix_three = window.innerWidth / 918;
  
  // 基础垂直偏移计算
  matrix_six = window.innerHeight - 506 - 58;
  
  // 屏幕宽度适配
  if (window.innerWidth <= 1024) {
    matrix_one = 2.24468;
    matrix_three = 2.24468;
    matrix_six = 341.6;
  } else if (window.innerWidth > 1024 && window.innerWidth <= 1440) {
    // 在1440-1024区间内，重新计算scale确保充满屏幕
    matrix_one = window.innerWidth / 918;
    matrix_three = window.innerWidth / 918;
    matrix_six = 149.6;
  } else if (window.innerWidth >= 2048) {
    matrix_six = (window.innerHeight / 2) - 58;
  }
  
  // 苹果设备适配（优先级更高）
  if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
    if (window.innerHeight <= 892) {
      matrix_six = (window.innerHeight / 3.7) - 58;
    } else {
      matrix_six = (window.innerHeight / 2.7) - 58;
    }
  }
  
  return { matrix_one, matrix_three, matrix_six };
}

// 初始化matrix值
let { matrix_one, matrix_three, matrix_six } = calculateMatrixValues();

document.addEventListener('DOMContentLoaded', function () {
  // 重新计算matrix值
  ({ matrix_one, matrix_three, matrix_six } = calculateMatrixValues());
  
  let scalingContainer = document.querySelector('.section-hero .scaling-container');
  if (scalingContainer) {
    let scale = matrix_one;
    let skew = matrix_six;
    scalingContainer.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, ${skew})`;
  }
});
window.addEventListener('resize', function () {
  // 重新计算matrix值
  ({ matrix_one, matrix_three, matrix_six } = calculateMatrixValues());

  let scalingContainer = document.querySelector('.section-hero .scaling-container');
  if (scalingContainer) {
    let scale = matrix_one;
    let skew = matrix_six;
    scalingContainer.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, ${skew})`;
  }
});

document.addEventListener('scroll', function () {
  let scalingContainer = document.querySelector('.scaling-container');
  if (scalingContainer) {
    // 在滚动时也动态计算matrix值，确保响应屏幕尺寸变化
    const { matrix_one: current_matrix_one, matrix_three: current_matrix_three, matrix_six: current_matrix_six } = calculateMatrixValues();
    
    let videoMedia = document.querySelector('.inline-video-media video');
    let videoFrameStatic = document.querySelector('.inline-video-frame-static');
    let overviewHeroTvShadowColor = document.querySelector('.overview-hero-hero-tv-shadow-color');
    let overviewHeroTvRemote = document.querySelector('.overview-hero-hero-tv-remote');

    let maxScroll = window.innerHeight * 1.75 - window.innerHeight;
    let scrollFraction = window.scrollY / maxScroll;
    let scale = Math.max(0.8, current_matrix_one - scrollFraction * (current_matrix_one - 0.8));
    if (window.innerWidth <= 1024) {
      scale = Math.max(0.4, current_matrix_one - scrollFraction * (current_matrix_one - 0.4));
    }
    let skew = Math.max(0, current_matrix_six - scrollFraction * current_matrix_six);
    let scale_two = Math.max(0.5, 1 - scrollFraction / 2);
    let skew_two = Math.max(-30, 0 - scrollFraction * (current_matrix_six + 30));
    if (window.innerWidth >= 3840) {
      scale = Math.max(2, current_matrix_one - scrollFraction * (current_matrix_one - 2));
      skew = 400;
    }

    scalingContainer.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, ${skew})`;
    overviewHeroTvRemote.style.transform = `matrix(${scale_two}, 0, 0, ${scale_two}, 0, ${skew_two})`;

    if (overviewHeroTvShadowColor) {
      overviewHeroTvShadowColor.style.opacity = `${0 + scrollFraction}`;
    }

    if (scale < 1.5) {
      if (videoMedia) {
        videoMedia.style.opacity = '0';
      }
      if (videoFrameStatic) {
        videoFrameStatic.style.opacity = '1';
        overviewHeroTvShadowColor.classList.add('no-blur');

      }
    } else {
      if (videoMedia) {
        videoMedia.style.opacity = '1';
      }
      if (videoFrameStatic) {
        videoFrameStatic.style.opacity = '0';
        overviewHeroTvShadowColor.classList.remove('no-blur');
      }
    }

    let sectionContent = document.querySelector('.section-content');
    if (sectionContent) {
      let maxScroll = window.innerHeight * 1.75 - window.innerHeight;
      let scrollFraction = window.scrollY / maxScroll;
      sectionContent.style.opacity = `${Math.max(1, 0 + scrollFraction / 4)}`;
    }
    // if (scale < 1.1) {
    //   sectionContent.style.opacity = '1';
    // } else {
    //   sectionContent.style.opacity = '1';
    // }
    let headlineHero = document.querySelector('.headline-hero');
    if (headlineHero) {
      if (window.scrollY >= 10) {
        headlineHero.style.opacity = '0';
      } else {
        headlineHero.style.opacity = '1';
      }
    }
    let video_container = document.querySelector('.video-container');
    if (video_container) {
      if (window.scrollY >= 10) {
        video_container.style.filter = 'brightness(1)';
      } else {
        video_container.style.filter = 'brightness(0.6)';
      }
    }
  }
});

document.querySelectorAll('.blog_item').forEach(function (item) {
  item.addEventListener('click', function () {
    var dataUrl = item.getAttribute('data-url');
    if (dataUrl) {
      window.location.href = dataUrl;
    }
  });
});

let show_item_number = 1;
if (window.innerWidth > 1024) {
  show_item_number = 4
}
if (window.innerWidth > 767 && window.innerWidth <= 1024)  {
  show_item_number = 2
}
if (window.innerWidth <= 767)  {
  show_item_number = 1
}
// swiper slider
var influencers_swiper = new Swiper('.influencers_swiper', {
  autoplay: false,//可选选项，自动滑动
  slidesPerView: window.innerWidth > 767 ? 2 : 1,
  spaceBetween: window.innerWidth > 1023 ? 20 : 8,
  // loop: true,
  pagination: {
    el: '.influencers_swiper .swiper-pagination',
  },
  navigation: {
    nextEl: '.influencers_swiper .swiper-button-next',
    prevEl: '.influencers_swiper .swiper-button-prev',
  }
});

var blog_swiper = new Swiper('.blog_swiper', {
  autoplay: false,//可选选项，自动滑动
  slidesPerView: show_item_number,
  spaceBetween: window.innerWidth > 1023 ? 20 : 8,
  // loop: true,
  pagination: {
    el: '.blog_swiper .swiper-pagination',
  },
  navigation: {
    nextEl: '.blog_swiper .swiper-button-next',
    prevEl: '.blog_swiper .swiper-button-prev',
  }
});

var customer_swiper = new Swiper('.customer_swiper', {
  autoplay: false,//可选选项，自动滑动
  slidesPerView: show_item_number,
  spaceBetween: window.innerWidth > 1023 ? 20 : 8,
  // loop: true,
  pagination: {
    el: '.customer_swiper .swiper-pagination',
  },
  navigation: {
    nextEl: '.customer_swiper .swiper-button-next',
    prevEl: '.customer_swiper .swiper-button-prev',
  }
})

// 图片对比效果.
if (document.getElementById("slider")) {

  document.getElementById("slider").addEventListener("input", function (e) {
    let sliderPos = e.target.value;
    // Update the width of the foreground image
    document.querySelector('.foreground-img').style.width = `${sliderPos}%`;
    // Update the position of the slider button
    let compareContainer = document.querySelector('.compare_container');
    let sliderButton = document.querySelector('.slider-button');
    // 判断推拽方向，往左用 -10px，往右用 -0px
    if (!window._lastSliderPos) window._lastSliderPos = sliderPos;
    let lastPos = window._lastSliderPos;
    let direction = sliderPos - lastPos;
    if (direction < 0) {
      // 往左拖拽
      if(innerWidth <= 1024) {
        document.querySelector('.slider-button').style.left = `calc(${sliderPos}% - 2px)`;
      } else {
        document.querySelector('.slider-button').style.left = `calc(${sliderPos}% - 10px)`;
      }
    } else {
      // 往右拖拽
      document.querySelector('.slider-button').style.left = `calc(${sliderPos}% - 0px)`;
    }
    window._lastSliderPos = sliderPos;
  });
}

document.querySelectorAll('.nav_item').forEach(function (item) {
  item.addEventListener('click', function () {
    document.querySelectorAll('.nav_item').forEach(function (otherItem) {
      otherItem.classList.remove('active');
    });
    item.classList.add('active');
    var dataName = item.getAttribute('data-name');
    var targetElement = document.querySelector('[data-title="' + dataName + '"]');
    if (targetElement) {
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - 80, behavior: 'smooth' });
    }
  });
});
window.addEventListener('scroll', function () {
  var foundActive = false;
  document.querySelectorAll('.nav_item').forEach(function (item) {
    var dataName = item.getAttribute('data-name');
    var targetElement = document.querySelector('[data-title="' + dataName + '"]');
    if (targetElement) {
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      var elementHeight = targetElement.offsetHeight;
      var scrollPosition = window.pageYOffset + window.innerHeight / 2;

      if (!foundActive && scrollPosition >= elementPosition && scrollPosition < elementPosition + elementHeight) {
        document.querySelectorAll('.nav_item').forEach(function (otherItem) {
          otherItem.classList.remove('active');
        });
        item.classList.add('active');
        foundActive = true;
      } else {
        item.classList.remove('active');
      }
    }
    if (item.classList.contains('active')) {
      let sectionNav = document.querySelector('.section_nav');
      if (sectionNav) {
        sectionNav.scrollTo({
          left: item.offsetLeft - 10,
          behavior: 'smooth'
        });
      }
    }
  });
});

if (window.innerWidth > 1024) {
  // canvas帧动画
  let canvas = document.getElementById('animationCanvas');
if (canvas){
  let context = canvas?.getContext('2d');
  let frameCount = 31;
  let images = [];
  let currentFrame = 0;

  for (let i = 0; i < frameCount; i++) {
    let img = new Image();
    img.src = `https://cdn.shopify.com/s/files/1/0554/7445/4576/files/1_${i.toString().padStart(4, "0")}.webp?v=1740711265`; // Update the path to your frames
    images.push(img);
  }

  images[0].onload = function () {
    canvas.width = images[0].width;
    canvas.height = images[0].height;
    context.drawImage(images[0], 0, 0);
  };
  function updateFrame(index) {
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(images[index], 0, 0);
  }

  document.addEventListener('scroll', function () {
    let container = document.querySelector('.frame_animation_container');
    if (container && window.scrollY >= container.offsetTop - 58) {
      let maxScroll = window.innerHeight * 3 - window.innerHeight * 0.5;
      let containerScrollTop = window.scrollY - container.offsetTop + 58;
      let scrollFraction = containerScrollTop / maxScroll;

      if (innerWidth > 1024) {
        let maxScrollHeight = window.innerHeight / 2;
        let scrollFractionHeight = Math.min(1, containerScrollTop / maxScrollHeight);
        let translateX = 50 - scrollFractionHeight * 50;
        let scale = 1.5 - scrollFractionHeight * 0.5;
        canvas.style.transform = `translateX(${translateX}%) scale(${scale})`;
      }

      let frameIndex = Math.min(frameCount - 1, Math.floor(scrollFraction * frameCount));
      if (frameIndex !== currentFrame) {
        currentFrame = frameIndex;
        updateFrame(currentFrame);
      }

      if (innerWidth > 1024) {
        let rightPartOne = document.querySelector('.right_part_one');
        if (rightPartOne) {
          let title = rightPartOne.querySelector('.title');
          if (title) {
            let titleTop = title.getBoundingClientRect().top;
            if (titleTop <= 160) {
              rightPartOne.querySelectorAll('*').forEach(child => {
                child.style.opacity = '0';
                child.style.transform = 'translateY(-20px)';
              });
            } else {
              rightPartOne.querySelectorAll('*').forEach(child => {
                child.style.opacity = '';
                child.style.transform = '';
              });
            }
          }
        }
      }
    }
  });
}
}
document.querySelectorAll('.card_item').forEach(function (item) {
  item.addEventListener('click', function () {
    var dataLink = item.getAttribute('data-link');
    var dataMobileLink = item.getAttribute('data-mobileLink');
    var targetElement = document.querySelector('[data-title="' + dataLink + '"]');
    var targetMobileElement = document.querySelector('[data-mobileTitle="' + dataMobileLink + '"]');
    if (targetElement) {
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      // window.scrollTo({ top: elementPosition, behavior: 'smooth', duration: 360 });
      window.scrollTo({ top: elementPosition - 100, behavior: 'smooth', duration: 360 });
    }
    // if (targetMobileElement) {
    //   var elementMobilePosition = targetMobileElement.getBoundingClientRect().top + window.pageYOffset;
    //   window.scrollTo({ top: elementMobilePosition - 100, behavior: 'smooth', duration: 360 });
    // }
  });
});

// $(".bar_button").mousedown(function () {
//   $(this)
//     .parent()
//     .addClass("stop");
//   $(this)
//     .parent()
//     .next()
//     .addClass("stop");
//   $(this).attr("data-flag", "1");
// });
// $(".bar").mousedown(function () {
//   $(this)
//     .parent()
//     .addClass("stop");
//   $(this)
//     .parent()
//     .next()
//     .addClass("stop");
//   $(this).attr("data-flag", "1");
// });
// $(".div").mousemove(function (e) {
//   const temp = $(this)
//     .find(".bar_button")
//     .attr("data-flag");
//   const temp2 = $(this)
//     .find(".bar")
//     .attr("data-flag");
//   if (temp == "1") {
//     const w = $(this).width();
//     const x = e.offsetX;
//     const p = parseFloat((x / w).toFixed(2)) * 100;
//     $(this)
//       .children(".img1")
//       .css("width", p + "%");
//     $(this)
//       .children(".img2")
//       .css("left", p + "%");
//   }
//   if (temp2 == "1") {
//     const w = $(this).width();
//     const x = e.offsetX;
//     const p = parseFloat((x / w).toFixed(2)) * 100;
//     $(this)
//       .children(".img1")
//       .css("width", p + "%");
//     $(this)
//       .children(".img2")
//       .css("left", p + "%");
//   }
// });
// $(document).mouseup(function () {
//   $(".img1,.img2").removeClass("stop");
//   $(".bar").attr("data-flag", "0");
//   $(".bar_button").attr("data-flag", "0");
// });